var _path, _path2, _g, _path3, _g2, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApprovalShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9833_5420)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9833_5420",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V15H16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9833_5420)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9833_5420",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V15H16V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9833_5420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.95233 0.138612L12.7191 2.87516C13.0422 3.04872 13.2446 3.37886 13.2487 3.73907V9.74499C13.2435 10.1049 13.0415 10.4345 12.7191 10.6089L5.12407 14.9646C5.00116 15.0357 4.84257 14.9964 4.76921 14.8767C4.7465 14.8389 4.73375 14.7963 4.73213 14.7525V12.1091L2.12632 10.6089C1.80393 10.4345 1.60184 10.1049 1.59668 9.74499V3.73907C1.60073 3.37886 1.80314 3.04872 2.12632 2.87516L6.89305 0.138612C7.2208 -0.046204 7.62459 -0.046204 7.95233 0.138612Z",
    fill: "url(#paint0_linear_9833_5420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.004C11.481 3.03585 10.9917 3.25636 10.624 3.62401C10.2564 3.99165 10.0358 4.48105 10.004 5H9.996C9.96421 4.48103 9.74371 3.9916 9.37605 3.62395C9.0084 3.25629 8.51897 3.03579 8 3.004V2.996C8.51897 2.96421 9.0084 2.74371 9.37605 2.37605C9.74371 2.0084 9.96421 1.51897 9.996 1H10.004C10.0358 1.51895 10.2564 2.00835 10.624 2.37599C10.9917 2.74364 11.481 2.96415 12 2.996V3.004Z",
    fill: "url(#paint1_radial_9833_5420)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9833_5420",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V15H16V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9833_5420)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.95233 0.138612L12.7191 2.87516C13.0422 3.04872 13.2446 3.37886 13.2487 3.73907V9.74499C13.2435 10.1049 13.0415 10.4345 12.7191 10.6089L5.12407 14.9646C5.00116 15.0357 4.84257 14.9964 4.76921 14.8767C4.7465 14.8389 4.73375 14.7963 4.73213 14.7525V12.1091L2.12632 10.6089C1.80393 10.4345 1.60184 10.1049 1.59668 9.74499V3.73907C1.60073 3.37886 1.80314 3.04872 2.12632 2.87516L6.89305 0.138612C7.2208 -0.046204 7.62459 -0.046204 7.95233 0.138612Z",
    fill: "url(#paint2_linear_9833_5420)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.004C11.481 3.03585 10.9917 3.25636 10.624 3.62401C10.2564 3.99165 10.0358 4.48105 10.004 5H9.996C9.96421 4.48103 9.74371 3.9916 9.37605 3.62395C9.0084 3.25629 8.51897 3.03579 8 3.004V2.996C8.51897 2.96421 9.0084 2.74371 9.37605 2.37605C9.74371 2.0084 9.96421 1.51897 9.996 1H10.004C10.0358 1.51895 10.2564 2.00835 10.624 2.37599C10.9917 2.74364 11.481 2.96415 12 2.996V3.004Z",
    fill: "url(#paint3_radial_9833_5420)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 10C13 12.2091 11.2091 14 9 14C6.79086 14 5 12.2091 5 10C5 7.79086 6.79086 6 9 6C11.2091 6 13 7.79086 13 10ZM9 8.3C8.75148 8.3 8.55 8.50147 8.55 8.75C8.55 8.91568 8.41568 9.05 8.25 9.05C8.08432 9.05 7.95 8.91568 7.95 8.75C7.95 8.1701 8.42012 7.7 9 7.7C9.57988 7.7 10.05 8.1701 10.05 8.75C10.05 9.03434 9.9366 9.2928 9.7532 9.4816C9.71628 9.51956 9.68108 9.55476 9.64748 9.58832C9.56116 9.67456 9.48552 9.75012 9.41916 9.8354C9.33156 9.94796 9.3 10.0307 9.3 10.1V10.4C9.3 10.5657 9.16568 10.7 9 10.7C8.83432 10.7 8.7 10.5657 8.7 10.4V10.1C8.7 9.83792 8.822 9.62576 8.94568 9.46688C9.03716 9.34932 9.15216 9.23452 9.24552 9.14138C9.27368 9.11328 9.29984 9.08716 9.3228 9.06351C9.40184 8.98217 9.45 8.87202 9.45 8.75C9.45 8.50147 9.24852 8.3 9 8.3ZM9 12C9.22092 12 9.4 11.8209 9.4 11.6C9.4 11.3791 9.22092 11.2 9 11.2C8.77908 11.2 8.6 11.3791 8.6 11.6C8.6 11.8209 8.77908 12 9 12Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9833_5420",
    x1: 4.69857,
    y1: 2.88773,
    x2: 13.5,
    y2: 12.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#645EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3BF5D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9833_5420",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.397 2.62575) rotate(23.8875) scale(3.3937 27.1856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#A9A2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9833_5420",
    x1: 4.69857,
    y1: 2.88773,
    x2: 13.5,
    y2: 12.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#665DFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E274D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_9833_5420",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.397 2.62575) rotate(23.8875) scale(3.3937 27.1856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#A9A2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9833_5420"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalShort);
export default __webpack_public_path__ + "static/media/Approval-Short.8247eadf3ea9f442a6d42ea72b94741f.svg";
export { ForwardRef as ReactComponent };